import { Folder } from '@dc-shared-web/hooks/api/folder/types'
import { CubeFolder, mapCubeToFolder } from '@dc-shared-web/lib'
import { AxiosInstance } from 'axios'

type GetFolderForMoveQueryParams = {
  currentTeamId: number
}

export const fetchFoldersForMove = async (
  apiClient: AxiosInstance,
  params: GetFolderForMoveQueryParams
): Promise<Folder[]> => {
  const {
    data: { data },
  } = await apiClient.get(`/ajax/cube/move_folders`, { params })
  return data
    .map((cubeFolder: CubeFolder) => mapCubeToFolder(cubeFolder))
    .sort((a: Folder, b: Folder) => {
      // Compare the project names and return -1, 0, or 1
      const nameA = a.name.toString().toLowerCase()
      const nameB = b.name.toString().toLowerCase()
      if (nameA < nameB) {
        return -1
      }
      if (nameA > nameB) {
        return 1
      }
      return 0
    })
}
